export default "__VITE_ASSET__DCF$t15C__"